/* =============================================================================
 * Delta Clothing — product-form / quick-add submit (thin wrapper)
 *
 * Heavy lifting lives in b2b-cart-add.js (loaded before this file).
 * This file remains so theme.liquid does not need renumbering everywhere;
 * it is a no-op when DLC.cartAdd is present.
 * ============================================================================= */
(function () {
  if (!window.B2B || window.__dlc_product_form_bridge_installed) return;
  window.__dlc_product_form_bridge_installed = true;
  if (window.DLC && window.DLC.cartAdd) return;
})();
